/**
 * Netlik (blur) skoru — Laplacian varyansı.
 * Görüntü grileştirilir, 3x3 Laplacian çekirdeği uygulanır, sonucun varyansı alınır.
 * Yüksek varyans = keskin kenarlar = net görüntü. Düşük varyans = bulanık.
 */
export function laplacianVariance(canvas: HTMLCanvasElement): number {
  const ctx = canvas.getContext("2d")!;
  const { width: w, height: h } = canvas;
  const { data } = ctx.getImageData(0, 0, w, h);

  // Gri tonlama (luma).
  const gray = new Float32Array(w * h);
  for (let i = 0; i < w * h; i++) {
    const r = data[i * 4], g = data[i * 4 + 1], b = data[i * 4 + 2];
    gray[i] = 0.299 * r + 0.587 * g + 0.114 * b;
  }

  // Laplacian: merkez*4 - (üst+alt+sol+sağ). Kenar pikselleri atlanır.
  let sum = 0;
  let sumSq = 0;
  let n = 0;
  for (let y = 1; y < h - 1; y++) {
    for (let x = 1; x < w - 1; x++) {
      const i = y * w + x;
      const lap = 4 * gray[i] - gray[i - 1] - gray[i + 1] - gray[i - w] - gray[i + w];
      sum += lap;
      sumSq += lap * lap;
      n++;
    }
  }
  if (n === 0) return 0;
  const mean = sum / n;
  return sumSq / n - mean * mean;
}

/**
 * Ortalama parlaklık (luma), 0-255 aralığı. Düşük ışık koşullarını yakalamak
 * için kullanılır. luma = 0.299*R + 0.587*G + 0.114*B, tüm piksellerin ortalaması.
 */
export function averageLuma(canvas: HTMLCanvasElement): number {
  const ctx = canvas.getContext("2d")!;
  const { width: w, height: h } = canvas;
  const { data } = ctx.getImageData(0, 0, w, h);

  let sum = 0;
  const n = w * h;
  for (let i = 0; i < n; i++) {
    const r = data[i * 4], g = data[i * 4 + 1], b = data[i * 4 + 2];
    sum += 0.299 * r + 0.587 * g + 0.114 * b;
  }
  return n === 0 ? 0 : sum / n;
}
